import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Button = (props) => {
  const {
    type,
    onClick,
    text,
    style,
    disabled,
  } = props;
  const body = text || {
    back: 'Indietro',
    submit: 'Prosegui',
  }[type];

  const baseClass = type === 'next' ? 'btn-submit' : `btn-${type}`;
  const classes = classNames(baseClass, { 'btn--disabled': disabled });

  if (!onClick && type !== 'next') {
    return <input type="submit" value={body} className={classes} />;
  }

  if (type === 'next') {
    return (
      <a href="#" onClick={e => e.preventDefault() & onClick()} className={classes} style={style}>
        {body}
        <i className="bi_interface-right" />
      </a>
    );
  }

  if (type === 'secondary') {
    return (
      <button href="#" onClick={onClick} className={classes} style={style}>
        {body}
      </button>
    );
  }

  return (
    <a href="#" onClick={e => e.preventDefault() & onClick()} className={classes} style={style}>
      {type === 'back' && <i className="bi_interface-left" />}
      {body}
    </a>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/button.js